import moment from "moment";
import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Label } from "src/ui";
 import "./CountdownChart.scss";

interface IProps {
    item: Spintr.PlannerItem;
}

const CountdownChart = (props: IProps) => {
    const [timeLeft, setTimeLeft] = useState<string>();
    const [progress, setProgress] = useState<number>();

    useEffect(() => {
        let interval;

        const updateProgress = () => {
            setProgress(
                Math.min(1, moment().diff(props.item.startsAt) / moment(props.item.endsAt).diff(props.item.startsAt))
            );

            const diff = moment(props.item.endsAt).diff(moment());
            const totalMinutes = Math.max(0, Math.ceil(diff / (1000 * 60))); // Round UP to include leftover seconds
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            setTimeLeft(moment.utc().startOf("day").add({ hours, minutes }).format("HH:mm"));
        };

        updateProgress();

        interval = setInterval(() => {
            updateProgress();
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="CountdownChart">
            <div className="chart-wrapper">
                <Doughnut
                    options={{
                        responsive: true,
                        maintainAspectRatio: true,
                        cutout: 20,
                        plugins: {
                            legend: {
                                display: false,
                            },
                            tooltip: {
                                enabled: false,
                            },
                        },
                        elements: {
                            arc: {
                                borderWidth: 0,
                            },
                        },
                        hover: {
                            mode: null,
                        },
                    }}
                    data={{
                        datasets: [
                            {
                                data: [progress, 1 - progress],
                                backgroundColor: ["#F1AE15", "#FCEFD0"],
                                borderRadius: [4, 0],
                            },
                        ],
                    }}
                />
                <Label size="body-2" weight="medium">
                    {timeLeft}
                </Label>
            </div>
        </div>
    );
};

export default CountdownChart;
